import React from 'react'
import { useCountUp } from 'use-count-up'
import { isFinite } from 'lodash'
import { Progress } from '..'
import { colors, spacing } from '../../style/constants'
import './styles.scss'
import { SpinnerThird } from '../../icons'

const PERCENT_ANIMATION_DURATION = 1 // sec 1

interface CommuteScoreProgressProps {
  /**
   * Defines the final score, thus we don't apply count up animation.
   * NOTE that this won't work if passed in parallel of percent
   */
  score?: number | undefined
  percent?: number | undefined
  isLoading?: boolean
}

export function CommuteScoreProgress({ percent, score, isLoading }: CommuteScoreProgressProps) {
  const { value: percentCountUp } = useCountUp({
    isCounting: Boolean(score && !isLoading && !percent),
    start: 0,
    end: score,
    duration: PERCENT_ANIMATION_DURATION
  })
  // eslint-disable-next-line @typescript-eslint/no-base-to-string -- Works like this
  const currentPercent = percentCountUp ? parseInt(percentCountUp.toString()) : 0

  const renderSpinner = () => <SpinnerThird />
  return (
    <Progress
      className="app-commute-score-progress"
      percent={isFinite(percent) ? percent : currentPercent}
      showInfo={isLoading}
      format={renderSpinner}
      size={['100%', 16]}
      strokeColor={{
        '0%': colors.accentGreen100,
        '50%': colors.accentGreen400,
        '100%': colors.feedbackSuccess600
      }}
      trailColor={colors.neutral300}
      style={{ marginRight: 0, marginBottom: spacing.small, backgroundColor: 'transparent' }}
    />
  )
}
